const translations = {
    address1: 'Address',
    address2: 'Address line 2',
    city: 'City',
    latitude: 'Latitude',
    longitude: 'Longitude',
    siteName: 'Site name',
    state: 'State',
    zipCode: 'ZIP code'
};

export default translations;
